// sort by alphabet
import type { GridColumn, GridRow } from '@omnia/ui/src/lib'
import { GridAccordion } from '@/features/grid/accordion/Accordion'
import { Button } from '@/features/grid/button/Button'
import { Headline } from '@/features/grid/headline/Headline'
import { Media } from '@/features/grid/media/Media'
import { RichText } from '@/features/grid/richText/RichText'
import { VideoEmbed } from '@/features/grid/videoEmbed/VideoEmbed'
import { FilmList } from './filmList/FilmList'
import type { GridCommonSettingsPropsApi } from './gridCommonSettings.models'
import { UmbracoForm } from './umbracoForm/UmbracoForm'

export type CineColombiaGridRow = GridRow<GridCommonSettingsPropsApi, GridCommonSettingsPropsApi>
export type CineColombiaGridColumn = GridColumn<GridCommonSettingsPropsApi>

export const GridTypes = {
    gridAccordion: GridAccordion,
    gridButton: Button,
    gridFilmList: FilmList,
    gridHeadline: Headline,
    gridImage: Media,
    gridRichText: RichText,
    gridUmbracoForm: UmbracoForm,
    gridVideoEmbed: VideoEmbed,
}
